{
  "labels": {
    "paste": "Pegar",
    "pasteAsPlaintext": "Pegar coma texto sen formato",
    "pasteCharts": "Pegar gráficos",
    "selectAll": "Seleccionar todo",
    "multiSelect": "Engadir elemento á selección",
    "moveCanvas": "Mover o lenzo",
    "cut": "Cortar",
    "copy": "Copiar",
    "copyAsPng": "Copiar no portapapeis como PNG",
    "copyAsSvg": "Copiar no portapapeis como SVG",
    "copyText": "Copia no portapapeis como texto",
    "copySource": "Copiar fonte ao portapapeis",
    "convertToCode": "Converter a código",
    "bringForward": "Traer cara adiante",
    "sendToBack": "Enviar cara atrás",
    "bringToFront": "Traer á fronte",
    "sendBackward": "Enviar ao fondo",
    "delete": "Borrar",
    "copyStyles": "Copiar estilo",
    "pasteStyles": "Pegar estilo",
    "stroke": "Trazo",
    "changeStroke": "",
    "background": "Fondo",
    "changeBackground": "",
    "fill": "Recheo",
    "strokeWidth": "Largo do trazo",
    "strokeStyle": "Estilo do trazo",
    "strokeStyle_solid": "Sólido",
    "strokeStyle_dashed": "Liña de trazos",
    "strokeStyle_dotted": "Liña de puntos",
    "sloppiness": "Estilo de trazo",
    "opacity": "Opacidade",
    "textAlign": "Aliñar texto",
    "edges": "Bordos",
    "sharp": "Agudo",
    "round": "Redondo",
    "arrowheads": "Puntas de frecha",
    "arrowhead_none": "Ningunha",
    "arrowhead_arrow": "Frecha",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Círculo",
    "arrowhead_circle_outline": "Círculo (contorno)",
    "arrowhead_triangle": "Triángulo",
    "arrowhead_triangle_outline": "Triángulo (contorno)",
    "arrowhead_diamond": "Diamante",
    "arrowhead_diamond_outline": "Diamante (contorno)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "",
    "arrowtype_sharp": "",
    "arrowtype_round": "",
    "arrowtype_elbowed": "",
    "fontSize": "Tamaño da fonte",
    "fontFamily": "Tipo de fonte",
    "addWatermark": "Engadir \"Feito con Excalidraw\"",
    "handDrawn": "Debuxado a man",
    "normal": "Normal",
    "code": "Código",
    "small": "Pequeno",
    "medium": "Mediano",
    "large": "Grande",
    "veryLarge": "Moi grande",
    "solid": "Sólido",
    "hachure": "Folleto",
    "zigzag": "Zigzag",
    "crossHatch": "Raiado transversal",
    "thin": "Estreito",
    "bold": "Groso",
    "left": "Esquerda",
    "center": "Centrado",
    "right": "Dereita",
    "extraBold": "Moi groso",
    "architect": "Arquitecto",
    "artist": "Artista",
    "cartoonist": "Caricatura",
    "fileTitle": "Nome do arquivo",
    "colorPicker": "Selector de cor",
    "canvasColors": "Usado en lenzo",
    "canvasBackground": "Fondo do lenzo",
    "drawingCanvas": "Lenzo de debuxo",
    "clearCanvas": "",
    "layers": "Capas",
    "actions": "Accións",
    "language": "Idioma",
    "liveCollaboration": "Colaboración en directo...",
    "duplicateSelection": "Duplicar",
    "untitled": "Sen título",
    "name": "Nome",
    "yourName": "O teu nome",
    "madeWithExcalidraw": "Feito con Excalidraw",
    "group": "Agrupar selección",
    "ungroup": "Desagrupar selección",
    "collaborators": "Colaboradores",
    "toggleGrid": "",
    "addToLibrary": "Engadir á biblioteca",
    "removeFromLibrary": "Eliminar da biblioteca",
    "libraryLoadingMessage": "Cargando biblioteca…",
    "libraries": "Explorar bibliotecas",
    "loadingScene": "Cargando escena…",
    "loadScene": "",
    "align": "Aliñamento",
    "alignTop": "Aliñamento superior",
    "alignBottom": "Aliñamento inferior",
    "alignLeft": "Aliñar a esquerda",
    "alignRight": "Aliñar a dereita",
    "centerVertically": "Centrar verticalmente",
    "centerHorizontally": "Centrar horizontalmente",
    "distributeHorizontally": "Distribuír horizontalmente",
    "distributeVertically": "Distribuír verticalmente",
    "flipHorizontal": "Virar horizontalmente",
    "flipVertical": "Virar verticalmente",
    "viewMode": "Modo de visualización",
    "share": "Compartir",
    "showStroke": "Mostrar selector de cores do trazo",
    "showBackground": "Mostrar selector de cores do fondo",
    "showFonts": "",
    "toggleTheme": "",
    "theme": "",
    "personalLib": "Biblioteca Persoal",
    "excalidrawLib": "Biblioteca Excalidraw",
    "decreaseFontSize": "Diminuír tamaño da fonte",
    "increaseFontSize": "Aumentar o tamaño da fonte",
    "unbindText": "Desvincular texto",
    "bindText": "Ligar o texto ao contedor",
    "createContainerFromText": "Envolver o texto nun contedor",
    "link": {
      "edit": "Editar ligazón",
      "editEmbed": "",
      "create": "",
      "label": "Ligazón",
      "labelEmbed": "",
      "empty": "Non se estableceu un enlace",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "Editar liña",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "Bloquear",
      "unlock": "Desbloquear",
      "lockAll": "Bloquear todo",
      "unlockAll": "Desbloquear todo"
    },
    "statusPublished": "Publicado",
    "sidebarLock": "Manter a barra lateral aberta",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "Texto a diagrama",
    "prompt": "",
    "followUs": "Síguenos",
    "discordChat": "Chat de Discord",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "",
    "zoomToFit": "",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "",
    "wrapSelectionInFrame": "",
    "tab": "",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "Aínda non hai elementos engadidos...",
    "hint_emptyLibrary": "Seleccione un elemento no lenzo para engadilo aquí, ou instale unha biblioteca dende o repositorio público, como se detalla a continuación.",
    "hint_emptyPrivateLibrary": "Seleccione un elemento do lenzo para engadilo aquí.",
    "search": {
      "inputPlaceholder": "",
      "heading": "",
      "noResults": "",
      "clearSearch": ""
    }
  },
  "search": {
    "title": "",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "",
    "texts": ""
  },
  "buttons": {
    "clearReset": "Limpar o lenzo",
    "exportJSON": "Exportar a arquivo",
    "exportImage": "Exportar imaxe...",
    "export": "Gardar en...",
    "copyToClipboard": "Copiar ao portapapeis",
    "copyLink": "",
    "save": "Gardar no ficheiro actual",
    "saveAs": "Gardar como",
    "load": "Abrir",
    "getShareableLink": "Obter unha ligazón que se poida compartir",
    "close": "Pechar",
    "selectLanguage": "Seleccionar idioma",
    "scrollBackToContent": "Volver ao contido",
    "zoomIn": "Ampliar",
    "zoomOut": "Reducir",
    "resetZoom": "Reiniciar zoom",
    "menu": "Menú",
    "done": "Feito",
    "edit": "Editar",
    "undo": "Desfacer",
    "redo": "Refacer",
    "resetLibrary": "Reiniciar biblioteca",
    "createNewRoom": "Crear nova sala",
    "fullScreen": "Pantalla completa",
    "darkMode": "Modo escuro",
    "lightMode": "Modo claro",
    "systemMode": "",
    "zenMode": "Modo zen",
    "objectsSnapMode": "",
    "exitZenMode": "Saír do modo zen",
    "cancel": "Cancelar",
    "saveLibNames": "",
    "clear": "Limpar",
    "remove": "Eliminar",
    "embed": "",
    "publishLibrary": "",
    "submit": "Enviar",
    "confirm": "Confirmar",
    "embeddableInteractionButton": "Faga clic para interactuar"
  },
  "alerts": {
    "clearReset": "Isto limpará todo o lenzo. Estás seguro?",
    "couldNotCreateShareableLink": "Non se puido crear unha ligazón para compartir.",
    "couldNotCreateShareableLinkTooBig": "Non se puido crear a ligazón para compartir: a escena é demasiado grande",
    "couldNotLoadInvalidFile": "Non se puido cargar o ficheiro non válido",
    "importBackendFailed": "A importación dende o backend fallou.",
    "cannotExportEmptyCanvas": "Non se pode exportar un lenzo baleiro.",
    "couldNotCopyToClipboard": "Non se puido copiar ao portapapeis.",
    "decryptFailed": "Non se poideron descifrar os datos.",
    "uploadedSecurly": "A carga foi asegurada con cifrado de extremo a extremo, o que significa que o servidor de Excalidraw e terceiros non poden ler o contido.",
    "loadSceneOverridePrompt": "A carga dun debuxo externo substituirá o contido existente. Desexa continuar?",
    "collabStopOverridePrompt": "Deter a sesión, sobrescribirá o seu debuxo local previamente almacenado. Está seguro?\n\n(Se quere manter o seu debuxo local, simplemente peche a lapela do navegador.)",
    "errorAddingToLibrary": "Non se puido engadir o elemento á biblioteca",
    "errorRemovingFromLibrary": "Non se puido eliminar o elemento da biblioteca",
    "confirmAddLibrary": "Isto engadirá {{numShapes}} forma(s) a túa biblioteca. Estás seguro?",
    "imageDoesNotContainScene": "Esta imaxe non parece conter ningún dato da escena. Activou a inserción de escenas durante a exportación?",
    "cannotRestoreFromImage": "Non se puido restaurar a escena dende este arquivo de imaxe",
    "invalidSceneUrl": "Non se puido importar a escena dende a URL proporcionada. Ou ben está malformada ou non contén un JSON con información válida para Excalidraw.",
    "resetLibrary": "Isto limpará a súa biblioteca. Está seguro?",
    "removeItemsFromsLibrary": "Eliminar {{count}} elemento(s) da biblioteca?",
    "invalidEncryptionKey": "A clave de cifrado debe ter 22 caracteres. A colaboración en directo está desactivada.",
    "collabOfflineWarning": "Non hai conexión a Internet dispoñible.\nOs teus cambios non serán gardados!",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Tipo de ficheiro non soportado.",
    "imageInsertError": "Non se puido inserir a imaxe. Probe de novo máis tarde...",
    "fileTooBig": "O ficheiro é demasiado grande. O tamaño máximo permitido é {{maxSize}}.",
    "svgImageInsertError": "Non se puido inserir como imaxe SVG. O marcado SVG semella inválido.",
    "failedToFetchImage": "Non se puido obter a imaxe.",
    "cannotResolveCollabServer": "Non se puido conectar ao servidor de colaboración. Por favor recargue a páxina e probe de novo.",
    "importLibraryError": "Non se puido cargar a biblioteca",
    "saveLibraryError": "",
    "collabSaveFailed": "Non se puido gardar na base de datos. Se o problema persiste, deberías gardar o teu arquivo de maneira local para asegurarte de non perdelo teu traballo.",
    "collabSaveFailed_sizeExceeded": "Non se puido gardar na base de datos, o lenzo semella demasiado grande. Deberías gardar o teu arquivo de maneira local para asegurarte de non perdelo teu traballo.",
    "imageToolNotSupported": "As imaxes están desactivadas.",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "Non se puido copiar.",
    "copyToSystemClipboardFailed": "Non se puido copiar ao portapapeis."
  },
  "toolBar": {
    "selection": "Selección",
    "lasso": "",
    "image": "Inserir imaxe",
    "rectangle": "Rectángulo",
    "diamond": "Diamante",
    "ellipse": "Elipse",
    "arrow": "Frecha",
    "line": "Liña",
    "freedraw": "Debuxar",
    "text": "Texto",
    "library": "Biblioteca",
    "lock": "Manter a ferramenta seleccionada activa despois de debuxar",
    "penMode": "Modo lapis - evitar o contacto",
    "link": "",
    "eraser": "Goma de borrar",
    "frame": "",
    "magicframe": "",
    "embeddable": "Inserir na web",
    "laser": "Punteiro láser",
    "hand": "Man (ferramenta de desprazamento)",
    "extraTools": "Máis ferramentas",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "",
    "diamond": "",
    "ellipse": "",
    "arrow": "",
    "line": "",
    "freedraw": "",
    "text": "",
    "image": "",
    "group": "",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "selection": "",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Accións do lenzo",
    "selectedShapeActions": "Accións da forma seleccionada",
    "shapes": "Formas"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "",
    "linearElement": "Faga clic para iniciar varios puntos, arrastre para unha sola liña",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Fai clic e arrastra, solta cando acabes",
    "text": "Consello: tamén podes engadir texto facendo dobre-clic en calquera lugar coa ferramenta de selección",
    "embeddable": "Faga clic e arrastre para crear un sitio web embebido",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Publica a túa propia biblioteca",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "Esta función pódese activar establecendo a opción \"dom.events.asyncClipboard.clipboardItem\" a \"true\". Para cambiar as opcións do navegador en Firefox, visita a páxina \"about:config\".",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Non se pode mostrar a vista previa",
    "canvasTooBig": "Pode que o lenzo sexa demasiado grande.",
    "canvasTooBigTip": "Consello: Probe a acercar un pouco os elementos máis afastados."
  },
  "errorSplash": {
    "headingMain": "Atopouse un erro. Probe <button>recargando a páxina.</button>",
    "clearCanvasMessage": "Se recargar non funcionou, probe <button>limpando o lenzo.</button>",
    "clearCanvasCaveat": " Isto resultará nunha perda do seu traballo ",
    "trackedToSentry": "O erro con identificador {{eventId}} foi rastrexado no noso sistema.",
    "openIssueMessage": "Fomos moi cautelosos de non incluír a información da súa escena no erro. Se a súa escena non é privada, por favor, considere o seguimento do noso <button>rastrexador de erros.</button> Por favor inclúa a seguinte información copiándoa e pegándoa na issue de Github.",
    "sceneContent": "Contido da escena:"
  },
  "shareDialog": {
    "or": "Ou"
  },
  "roomDialog": {
    "desc_intro": "Invita xente a colaborar no teu diagrama.",
    "desc_privacy": "",
    "button_startSession": "Comezar sesión",
    "button_stopSession": "Rematar sesión",
    "desc_inProgressIntro": "A sesión de colaboración en directo está agora en progreso.",
    "desc_shareLink": "Comparte esta ligazón con calquera que queiras colaborar:",
    "desc_exitSession": "Deter a sesión desconectarao da sala, pero poderá seguir traballando coa escena de maneira local. Teña en conta que isto non afectará a outras persoas, que poderán seguir colaborando na súa versión.",
    "shareTitle": "Únase a unha sesión de colaboración en directo en Excalidraw"
  },
  "errorDialog": {
    "title": "Erro"
  },
  "exportDialog": {
    "disk_title": "Gardar no disco",
    "disk_details": "Exporte os datos da escena a un ficheiro que poderás importar máis tarde.",
    "disk_button": "Gardar nun ficheiro",
    "link_title": "Ligazón para compartir",
    "link_details": "Exportar como unha ligazón de só lectura.",
    "link_button": "Exportar a unha ligazón",
    "excalidrawplus_description": "Garde a escena no seu espazo de traballo en Excalidraw+.",
    "excalidrawplus_button": "Exportar",
    "excalidrawplus_exportError": "Non se puido exportar a Excalidraw+ neste momento..."
  },
  "helpDialog": {
    "blog": "Le o noso blog",
    "click": "clic",
    "deepSelect": "Selección en profundidade",
    "deepBoxSelect": "Selección en profundidade dentro da caixa, evitando o arrastre",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Frecha curva",
    "curvedLine": "Liña curva",
    "documentation": "Documentación",
    "doubleClick": "dobre-clic",
    "drag": "arrastrar",
    "editor": "Editor",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "Encontrou un problema? Envíeo",
    "howto": "Sigue as nosas normas",
    "or": "ou",
    "preventBinding": "Evitar a unión de frechas",
    "tools": "Ferramentas",
    "shortcuts": "Atallos de teclado",
    "textFinish": "Rematar de editar (editor de texto)",
    "textNewLine": "Engadir unha nova liña (editor de texto)",
    "title": "Axuda",
    "view": "Vista",
    "zoomToFit": "Zoom que se axuste a todos os elementos",
    "zoomToSelection": "Zoom á selección",
    "toggleElementLock": "Bloquear/desbloquear selección",
    "movePageUpDown": "Mover páxina cara enriba/abaixo",
    "movePageLeftRight": "Mover páxina cara a esquerda/dereita",
    "cropStart": "",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Limpar lenzo"
  },
  "publishDialog": {
    "title": "Publicar biblioteca",
    "itemName": "Nome do elemento",
    "authorName": "Nome do autor",
    "githubUsername": "Nome de usuario en Github",
    "twitterUsername": "Nome de usuario en Twitter",
    "libraryName": "Nome da biblioteca",
    "libraryDesc": "Descrición da biblioteca",
    "website": "Páxina web",
    "placeholder": {
      "authorName": "O seu nome ou nome de usuario",
      "libraryName": "Nome da súa biblioteca",
      "libraryDesc": "Descrición da súa biblioteca para axudar a xente a entender o seu uso",
      "githubHandle": "Nome de usuario de GitHub (opcional), así poderás editar a biblioteca unha vez enviada para a súa revisión",
      "twitterHandle": "Nome de usuario en Twitter(opcional), así sabemos a quen darlle crédito cando se lle de promoción a través de Twitter",
      "website": "Ligazón ao teu sitio web persoal ou a outro sitio (opcional)"
    },
    "errors": {
      "required": "Obrigatorio",
      "website": "Introduza unha URL válida"
    },
    "noteDescription": "Envíe a súa biblioteca para que sexa incluída no <link>repositorio público de bibliotecas</link>para que outra xente a poida usar nos seus debuxos.",
    "noteGuidelines": "A biblioteca necesita ser aprobada manualmente primeiro. Por favor, lea as <link>normas</link> antes de ser enviado. Necesitarás unha conta de GitHub para comunicarte ou facer cambios se se solicitan, pero non é estritamente necesario.",
    "noteLicense": "Ao enviar, estás de acordo con que a biblioteca sexa publicada baixo a <link>Licenza MIT, </link>o cal significa que, en resumo, calquera pode usalo sen restricións.",
    "noteItems": "Cada elemento da biblioteca debe ter o seu nome propio para que se poida filtrar. Os seguintes elementos da biblioteca serán incluídos:",
    "atleastOneLibItem": "Por favor seleccione polo menos un elemento da biblioteca para comezar",
    "republishWarning": "Nota: algúns dos elementos seleccionados están marcados como xa publicados/enviados. Só deberías reenviar elementos cando se actualice unha biblioteca ou envío."
  },
  "publishSuccessDialog": {
    "title": "Biblioteca enviada",
    "content": "Grazas {{authorName}}. A súa biblioteca foi enviada para ser revisada. Pode seguir o estado<link>aquí</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Restablecer biblioteca",
    "removeItemsFromLib": "Eliminar os elementos seleccionados da biblioteca"
  },
  "imageExportDialog": {
    "header": "Exportar imaxe",
    "label": {
      "withBackground": "Fondo",
      "onlySelected": "Só seleccionados",
      "darkMode": "Modo escuro",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": "Os datos da escena serán gardados no ficheiro PNG/SVG exportado polo que a escena poderá ser restaurada dende el. Isto aumentará o tamaño do ficheiro exportado."
    },
    "title": {
      "exportToPng": "Exportar a PNG",
      "exportToSvg": "Exportar a SVG",
      "copyPngToClipboard": "Copiar PNG ao portapapeis"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copiar ao portapapeis"
    }
  },
  "encrypted": {
    "tooltip": "Os teus debuxos están cifrados de punto a punto, polo que os servidores de Excalidraw nunca os verán.",
    "link": "Entrada do blog acerca do cifrado de punto a punto en Excalidraw"
  },
  "stats": {
    "angle": "Ángulo",
    "shapes": "",
    "height": "Alto",
    "scene": "Escena",
    "selected": "Seleccionado",
    "storage": "Almacenamento",
    "fullTitle": "",
    "title": "",
    "generalStats": "",
    "elementProperties": "",
    "total": "Total",
    "version": "Versión",
    "versionCopy": "Faga clic para copiar",
    "versionNotAvailable": "Versión non dispoñible",
    "width": "Ancho"
  },
  "toast": {
    "addedToLibrary": "Engadido á biblioteca",
    "copyStyles": "Estilos copiados.",
    "copyToClipboard": "Copiado ao portapapeis.",
    "copyToClipboardAsPng": "Copiar {{exportSelection}} ao portapapeis como PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Ficheiro gardado.",
    "fileSavedToFilename": "Gardado en {filename}",
    "canvas": "lenzo",
    "selection": "selección",
    "pasteAsSingleElement": "Usa {{shortcut}} para pegar como un único elemento\nou pega nun editor de texto existente",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Transparente",
    "black": "Negro",
    "white": "Branco",
    "red": "Vermello",
    "pink": "Rosa",
    "grape": "Uva",
    "violet": "Violeta",
    "gray": "Gris",
    "blue": "Azul",
    "cyan": "",
    "teal": "",
    "green": "Verde",
    "yellow": "Marelo",
    "orange": "Laranxa",
    "bronze": "Bronce"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "Queres ir a Excalidraw+ no seu lugar?",
      "menuHint": "Exportar, preferencias, idiomas, ..."
    },
    "defaults": {
      "menuHint": "Exportar, preferencias, e máis...",
      "center_heading": "Diagramas. Feito. Sinxelo.",
      "toolbarHint": "Escolle unha ferramenta & Comeza a debuxar!",
      "helpHint": "Atallos & axuda"
    }
  },
  "colorPicker": {
    "color": "",
    "mostUsedCustomColors": "",
    "colors": "Cores",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Exportar como imaxe",
        "button": "Exportar como imaxe",
        "description": ""
      },
      "saveToDisk": {
        "title": "Gardar no disco",
        "button": "Gardar no disco",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Exportar a Excalidraw+",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Cargar dende arquivo",
        "button": "Cargar dende arquivo",
        "description": ""
      },
      "shareableLink": {
        "title": "Cargar dende un enlace",
        "button": "Substituír o meu contido",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "Inserir",
    "description": "",
    "syntax": "",
    "preview": "Vista previa",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "",
      "assistant": "",
      "system": ""
    },
    "aiBeta": "",
    "label": "",
    "menu": "",
    "newChat": "",
    "deleteChat": "",
    "deleteMessage": "",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "",
    "insert": "",
    "retry": "",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": ""
  },
  "quickSearch": {
    "placeholder": ""
  },
  "fontList": {
    "badge": {
      "old": ""
    },
    "sceneFonts": "",
    "availableFonts": "",
    "empty": ""
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "Fai clic no usuario para seguilo",
      "followStatus": "Xa estás a seguir a este usuario",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "",
    "shortcuts": {
      "select": "",
      "confirm": "",
      "close": ""
    },
    "recents": "",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "",
    "option": "",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
